import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn(LocaleService, $filter, $scope, StateUtils, UserInfoService) {

    var ctrl = Object.create(BaseCtrl);
    var model = StateUtils.activeDataForState(true).model.value;

    ctrl.init = function () {
        $scope.effectiveDate = model.baseData.effectiveDate;
        $scope.startDate = model.baseData.periodStartDate;
        $scope.endDate = model.baseData.periodEndDate;

        var quoteData = model.quoteData.offeredQuotes[0].premium;
        $scope.previousPremium = quoteData.previousPolicyTotalCost;
        $scope.newPremium = quoteData.total;
        $scope.taxes = quoteData.taxes;
        $scope.newPremiumBeforeTaxes = quoteData.totalBeforeTaxes;
        $scope.changeInCost = {
            amount: quoteData.total.amount - quoteData.previousPolicyTotalCost.amount,
            currency: quoteData.total.currency
        };
        $scope.canNavigateToPaymentStep = !UserInfoService.isAgent();
    };

    return ctrl.create($scope);
};
fn.$inject = ['LocaleService', '$filter', '$scope', 'StateUtils', 'UserInfoService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/quote/quoteCtrl.js
// module id = 1867
// module chunks = 0